import { Box } from '@material-ui/core'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import React from 'react'
import { careStore } from '~/companies/care/care.store'
import { Button } from '~/components/button'
import { Drawer } from '~/components/drawer'
import { privacyPolicyModalStyled } from './privacy-policy.style'

export const PrivacyPolicyFeature = ({ open, onClose }) => {
	const { t } = useTranslation()

	return (
		<Drawer open={open} css={privacyPolicyModalStyled} disableEnforceFocus title={t('OUR_COMMITMENT_TO_PRIVACY')} onClose={onClose}>
			<Box className="wrap-policy">
				<Box className="content">
					<span dangerouslySetInnerHTML={{ __html: careStore.privacyPolicyContent }} />
				</Box>
				<Box mt={2} className="button-wrap">
					<Button type="button" onClick={onClose} color="primary" variant="outlined">
						{t('OK')}
					</Button>
				</Box>
			</Box>
		</Drawer>
	)
}
